import { Link } from "react-router-dom";
import { ArrowRight, CalendarClock, FolderOpen, ShieldCheck } from "lucide-react";
import { Shell } from "@/components/Shell";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";

export default function Page365() {
  const { user } = useAuth();
  const { t } = useT();
  const join = user ? "/app/richiesta/manutenzione-programmata" : `/login?next=${encodeURIComponent("/app/richiesta/manutenzione-programmata")}`;
  return (
    <Shell>
      <section className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 rise">
          <p className="eyebrow">{t("p365.eyebrow")}</p>
          <h1 className="mt-3 font-serif text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight" data-testid="p365-title">{t("p365.title")}</h1>
          <p className="mt-5 text-xl text-ink/85 font-medium leading-snug max-w-2xl">{t("p365.claim")}</p>
          <p className="mt-4 max-w-2xl text-ink/65 leading-relaxed">{t("p365.intro")}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to={join} data-testid="p365-cta-join" className="btn-primary">{t("cta.join365")} <ArrowRight size={16} /></Link>
            <Link to={user ? "/app/casa" : "/login?next=/app/casa"} data-testid="p365-cta-folder" className="btn-secondary"><FolderOpen size={16} /> {t("folder.title")}</Link>
          </div>
        </div>
        <div className="lg:col-span-5 rise rise-2"><img src="/img/trust-tablet.jpg" alt="Referente Ci penso io con la famiglia" className="h-[380px] w-full rounded-[2rem] object-cover border border-craft" /></div>
      </section>

      <section className="mt-24 grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="p365-points">
        {t("p365.points").map(([h, d]) => (
          <div key={h} className="card-craft p-6"><CalendarClock className="text-terracotta" /><h3 className="mt-4 font-serif text-2xl font-semibold">{h}</h3><p className="mt-2 text-sm text-ink/60 leading-relaxed">{d}</p></div>
        ))}
      </section>

      <section className="mt-24 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5"><p className="eyebrow">{t("p365.how")}</p><h2 className="mt-2 font-serif text-3xl sm:text-4xl font-semibold">{t("p365.howTitle")}</h2>
          <ol className="mt-6 space-y-4">{t("p365.steps").map((s, i) => <li key={s} className="flex gap-4"><span className="font-mono text-sm text-terracotta font-bold">0{i + 1}</span><span className="text-sm text-ink/75 leading-relaxed">{s}</span></li>)}</ol></div>
        <div className="lg:col-span-7 rounded-[2rem] bg-forest text-white p-8 grain">
          <ShieldCheck className="text-terracotta-light" />
          <h3 className="mt-4 font-serif text-3xl font-semibold">{t("p365.refTitle")}</h3>
          <p className="mt-3 text-white/80 leading-relaxed">{t("p365.refText")}</p>
          <Link to={join} data-testid="p365-cta-join-2" className="btn-primary mt-6">{t("cta.join365")}</Link>
        </div>
      </section>
    </Shell>
  );
}
